import Config from '../config/constants';
import axios from 'axios';

/** 탄소중립 포인트 인센티브 내역을 조회합니다. */
export const apiGetKeitiIncentiveList = async (
  params: {
    page?: number;
    limit?: number;
    rlvtDeFrom?: string;
    rlvtDeTo?: string;
    phone?: string;
    status?: string;
  },
  accessToken: string,
): Promise<any> => {
  const url = `${Config.API_HOST}/api/admin/keiti-incentive/list`;
  try {
    const response = await axios.get(url, {
      headers: { access_token: accessToken },
      params,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching keiti incentive list:', error);
    throw error;
  }
};

/**
 * KEITI 전송 상태 — **"안 보낸 날"** 을 돌려준다.
 * 목록 API 는 존재하는 행만 주므로 결측이 보이지 않는다. 2026-03~08 에
 * 60일 미전송을 아무도 못 본 이유가 그것이다.
 */
export const apiGetKeitiIncentiveHealth = async (
  days: number,
  accessToken: string,
): Promise<any> => {
  const url = `${Config.API_HOST}/api/admin/keiti-incentive/health`;
  const response = await axios.get(url, {
    headers: { access_token: accessToken },
    params: { days },
  });
  return response.data;
};

/** 탄소중립 포인트 인센티브 요약 통계를 조회합니다. */
export const apiGetKeitiIncentiveSummary = async (
  params: { rlvtDeFrom?: string; rlvtDeTo?: string },
  accessToken: string,
): Promise<any> => {
  const url = `${Config.API_HOST}/api/admin/keiti-incentive/summary`;
  try {
    const response = await axios.get(url, {
      headers: { access_token: accessToken },
      params,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching keiti incentive summary:', error);
    throw error;
  }
};
